<template>
  <div class="page-container">
    <el-card class="page-content" shadow="never">
      <div class="page-actions">
        <!-- <el-button
          class="el-icon-plus"
          type="primary"
          @click="showCreate"
          size="mini"
          >添加用户</el-button
        > -->
        <el-select
          :value="queryType"
          @change="setQueryType"
          placeholder="请选择账户类型"
          size="mini"
        >
          <el-option
            v-for="item in queryTypeList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <el-input
          placeholder="请输入内容"
          clearable
          v-model="queryValue"
          size="mini"
        >
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
        <el-input
          placeholder="请输入真实姓名"
          clearable
          v-model="realName"
          size="mini"
        >
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
        <el-select
          v-model="userStatus"
          placeholder="请选择用户状态"
          size="mini"
        >
          <el-option
            v-for="item in status"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <el-select v-model="userType" placeholder="请选择用户类型" size="mini">
          <el-option
            v-for="item in Shareholder"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <el-select
          v-model="vipLevel"
          clearable
          placeholder="请选择VIP等级"
          size="mini"
        >
          <el-option
            v-for="item in vipLevels"
            :key="item.code"
            :label="item.label"
            :value="Number(item.code)"
          >
          </el-option>
        </el-select>
        <el-select v-model="mark" placeholder="请筛选异常账户" size="mini">
          <el-option
            v-for="item in ifMark"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <el-button type="primary" @click="handleSearch" size="mini"
          >搜索</el-button
        >
        <el-button
          v-if="$hasPerm('tenant:user_info:search_contact')"
          type="primary"
          plain
          @click="handleShowAllContact"
          size="mini"
          >查询所有手机邮箱</el-button
        >
      </div>
      <user-list @refresh="refreshList"></user-list>
      <Create></Create>
      <el-dialog
        :visible.sync="contactGoogleVisible"
        title="谷歌验证码"
        width="300px"
        @close="closeContactGoogleDialog"
      >
        <el-form
          :model="contactGoogleForm"
          ref="contactGoogleForm"
          label-width="110px"
        >
          <el-form-item
            label="谷歌验证码"
            prop="googleCode"
            :rules="[
              {
                required: true,
                message: '请输入谷歌验证码',
              },
            ]"
          >
            <el-input v-model.trim="contactGoogleForm.googleCode"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer">
          <el-button @click="closeContactGoogleDialog">取消</el-button>
          <el-button type="primary" @click="confirmContactGoogle">确定</el-button>
        </div>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
import './store'
import UserList from './components/list'
import Create from './components/create'
import { mapState, mapActions, mapMutations } from 'vuex'
import { QUERY_TYPE, PAGINATION } from './constants'

export default {
  name: 'User',
  components: {
    UserList,
    Create,
  },
  data() {
    return {
      isShow: false,
      seletData: {},
      queryValue: '',
      realName: '',
      userStatus: '',
      userType: '',
      vipLevel: '',
      vipLevels: [],
      mark: null,
      showContactPlain: false,
      contactGoogleVisible: false,
      contactGoogleForm: {
        googleCode: '',
      },
      pendingContactQuery: null,
      USER_CONTACT_GOOGLE_EXPIRED_CODE: 9402,
      status: [
        { value: '', label: '全部' },
        { value: 0, label: '激活' },
        { value: '-1', label: '冻结' },
      ],
      Shareholder: [
        { value: '', label: '全部' },
        { value: 1, label: '模拟盘用户' },
        { value: 2, label: '普通用户' },
        { value: 3, label: '特殊账户' },
      ],
      // Shareholder: [
      //   { value: '1', label: '无效用户' },
      //   { value: '2', label: '普通用户' },
      //   { value: '3', label: '初级股东' },
      //   { value: '4', label: '中级股东' },
      //   { value: '5', label: '高级股东' }
      // ],
      ifMark: [
        { value: '', label: '全部' },
        { value: false, label: '异常账户' },
        { value: true, label: '正常账户' },
      ],
    }
  },
  computed: {
    ...mapState('userOld', ['queryType', 'queryTypeList', 'pagination']),
  },
  methods: {
    ...mapActions('userOld', [
      'list',
      'getVipUserEnums',
      'checkUserContactGoogleSession',
      'verifyUserContactGoogle',
    ]),
    ...mapMutations('userOld', ['setQueryType', 'setCreateVisible']),
    refreshList(data = {}) {
      this.loadList(data)
    },
    buildListQuery(data = {}) {
      return {
        queryType: this.queryType,
        queryValue: this.queryValue,
        realName: this.realName,
        userStatus: this.userStatus,
        userType: this.userType,
        vipLevel: this.vipLevel,
        mark: this.mark,
        showContactPlain: this.showContactPlain,
        ...this.pagination,
        ...data,
      }
    },
    loadList(data = {}) {
      return this.list(this.buildListQuery(data)).then((res) => {
        if (res && res.code === this.USER_CONTACT_GOOGLE_EXPIRED_CODE) {
          this.showContactPlain = false
          this.list(this.buildListQuery(data))
          this.openContactGoogleDialog(data)
        }
        return res
      })
    },
    showCreate() {
      this.setCreateVisible(true)
    },
    loadVipLevels() {
      return this.getVipUserEnums().then((res) => {
        if (res && res.code === 0) {
          this.vipLevels = (res.data && res.data.vipLevels) || []
        }
        return res
      })
    },
    handleSearch() {
      this.seletData = {
        queryType: this.queryType,
        queryValue: this.queryValue,
        realName: this.realName,
        userType: this.userType,
        userStatus: this.userStatus,
        vipLevel: this.vipLevel,
        mark: this.mark,
        showContactPlain: this.showContactPlain,
        ...PAGINATION,
      }
      this.loadList(PAGINATION)
    },
    handleShowAllContact() {
      this.checkUserContactGoogleSession().then((res) => {
        if (res && res.code === 0 && res.data === true) {
          this.showContactPlain = true
          this.handleSearch()
          return
        }
        this.openContactGoogleDialog(PAGINATION)
      })
    },
    openContactGoogleDialog(data = {}) {
      this.pendingContactQuery = data
      this.contactGoogleForm = {
        googleCode: '',
      }
      this.contactGoogleVisible = true
      this.$nextTick(() => {
        if (this.$refs.contactGoogleForm) {
          this.$refs.contactGoogleForm.clearValidate()
        }
      })
    },
    closeContactGoogleDialog() {
      if (this.$refs.contactGoogleForm) {
        this.$refs.contactGoogleForm.resetFields()
      }
      this.contactGoogleVisible = false
      this.pendingContactQuery = null
    },
    confirmContactGoogle() {
      this.$refs.contactGoogleForm.validate((valid) => {
        if (!valid) return
        this.verifyUserContactGoogle(this.contactGoogleForm.googleCode).then(
          (res) => {
            if (res && res.code === 0) {
              const query = this.pendingContactQuery || PAGINATION
              this.showContactPlain = true
              this.contactGoogleVisible = false
              this.pendingContactQuery = null
              this.contactGoogleForm = {
                googleCode: '',
              }
              this.loadList(query)
            }
          }
        )
      })
    },
  },
  created() {
    this.loadVipLevels()
    this.loadList({
      queryType: QUERY_TYPE[0].value,
      ...PAGINATION,
    })
  },
}
</script>

<style lang="less" scoped>
.page-actions {
  margin-bottom: 10px;
}
</style>
